import React from "react";
import { TableCell, Typography, Grid } from "@material-ui/core";
import { observer, inject } from "mobx-react";
import { computed } from "mobx";

import { IValuesStore } from "Stores/Values/types";
import { PermissionGroup } from "@src/Interfaces/Entity/PermissionGroup";
import PermissionGroupEdit from "./PGEdit/PGEdit";
import { IManagementStore } from "@src/Stores/Management/types";
import EntityDelete from "@src/Components/Common/EntityDelete/EntityDelete";
import { STTableRow } from "@src/Components/Ui/STTableRow";
import { IAuthStore } from "@src/Stores/Auth/types";
import { STTableCellTypography } from "@src/Components/Ui/STTableCellTypography";

interface IProps {
  permissionGroup: PermissionGroup;
  values?: IValuesStore;
  management?: IManagementStore;
  auth?: IAuthStore;
}

@inject("auth", "values", "management")
@observer
class PermissionGroupTableItem extends React.Component<IProps> {
  @computed get isActive() {
    return this.props.permissionGroup.state === this.props.values.states.Active;
  }
  
  @computed get adminPermissionGroupId() {
      return this.props.values?.common["AdminPermissionGroupId"];
  }
  handleRemove = async () => {
    await this.props.management.removePermissionGroup(this.props.permissionGroup.id);
  };

  render() {
    const permissionGroup: PermissionGroup = this.props.permissionGroup;
    return (
      <STTableRow className={"management-table-row"} hover isActive={this.isActive}>
        <TableCell component="th" scope="row" size="small">
          <Typography>
            <STTableCellTypography>{permissionGroup.name}</STTableCellTypography>
          </Typography>
        </TableCell>
        <TableCell size="small">
          <STTableCellTypography>{permissionGroup.description}</STTableCellTypography>
        </TableCell>
        <TableCell align="right" size="small">
          <Grid container wrap="nowrap" justify="flex-end">
            {this.props.auth.user.location.primary && (permissionGroup.id != this.adminPermissionGroupId) && (
              <>
                <PermissionGroupEdit permissionGroup={permissionGroup} />
                <EntityDelete onSubmit={this.handleRemove} />
              </>
            )}
          </Grid>
        </TableCell>
      </STTableRow>
    );
  }
}

export default PermissionGroupTableItem;
